import debugC from 'debug';

export const debug = debugC('inox-tools:aik-route-config');
